import type { Command } from "../types.ts";
import { formatDate, loadIndex } from "../../blog.ts";

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export const blog: Command = {
  name: "blog",
  aliases: ["posts", "writing"],
  description: "Read the blog. Try: /blog, or /blog <slug>",
  usage: "/blog [slug]",
  async run(ctx) {
    let posts;
    try {
      posts = await loadIndex();
    } catch (err) {
      ctx.print(String(err), "c-warn");
      ctx.print("Run `bun run build:blog` to generate posts from content/posts/.", "c-muted");
      return;
    }

    if (posts.length === 0) {
      ctx.print("No posts yet. Add a .md file to content/posts/.", "c-muted");
      return;
    }

    const slug = ctx.args[0]?.replace(/^\/+|\/+$/g, "");

    // `/blog <slug>` opens the post directly.
    if (slug) {
      const post = posts.find((p) => p.slug === slug);
      if (!post) {
        ctx.print(`No post "${slug}". Type /blog to list them.`, "c-warn");
        return;
      }
      if (!ctx.term.router) {
        // No pane available — fall back to a real navigation.
        location.href = `/blog/${post.slug}`;
        return;
      }
      ctx.printHTML(`opening <span class="c-accent">${esc(post.title)}</span> …`);
      await ctx.term.router.openPost(post.slug);
      return;
    }

    // Otherwise list everything. Each row is a real link (so it can be
    // middle-clicked or copied) that the terminal intercepts to open a pane.
    ctx.printHTML(`<span class="label">posts</span>`);
    ctx.print("");
    for (const p of posts) {
      ctx.printHTML(
        `  <a class="link" href="/blog/${esc(p.slug)}" data-post="${esc(p.slug)}">${esc(p.title)}</a>` +
          `<br>&nbsp;&nbsp;<span class="c-dim">${esc(formatDate(p.date))} · ${p.readingMinutes} min` +
          (p.tags.length ? ` · ${esc(p.tags.join(", "))}` : "") +
          `</span>` +
          (p.description ? `<br>&nbsp;&nbsp;<span class="c-muted">${esc(p.description)}</span>` : ""),
      );
      ctx.print("");
    }
    ctx.printHTML(
      `<span class="c-dim">click a title, or type</span> <span class="c-accent">/blog ${esc(
        posts[0]!.slug,
      )}</span>`,
    );
  },
};
